<template>
  <slideout-panel v-on:slideout:close="closePanel" :open="updateEmailSettingPanelIsOpen" title="Update Email Setting" >
    <div>
      <update-email-settings-form  />
    </div>
  </slideout-panel>
</template>

<script>
import SlideoutPanel from "@/components/Functional/SlideoutPanel";
import UpdateEmailSettingsForm from "@/components/EmailSettings/UpdateEmailSettingsForm";
export default {
  name: "UpdateEmailSettingPanel",
  components: {UpdateEmailSettingsForm, SlideoutPanel},
  props: ['open'],
  methods: {
    closePanel() {
      this.$store.dispatch('closeUpdateEmailSettingPanel')
    }
  },
  computed: {
    updateEmailSettingPanelIsOpen() {
      return this.$store.getters.getUpdateEmailSettingPanelIsOpen
    },
  },
}
</script>

<style scoped>

</style>
